import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
} from "../../../utils";

import {
  courseChapterBreadcrumbs,
  courseChaptersRoutesObj,
} from "@routes/facultyMember/courseManagement/courseChapter/path";

// Base route constant
const baseRoute = `${courseChaptersRoutesObj.view}/exercise` as const;

// * Route configuration object for courseChapterExercise-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const courseChapterExerciseRoutesObj = {
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:exerciseId`,
  edit: `${baseRoute}/edit/:exerciseId`,
} as const;

// ! these are breadcrumbs translation not page title
const courseChapterExerciseRouteTranslation: IRouteTranslation<
  typeof courseChapterExerciseRoutesObj
> = {
  create: "addExercise",
  edit: "editExercise",
  view: "viewExercise",
};

// * Extracts the route parameters for the course-chapter-Exercises route configuration.
export type ICourseChapterExerciseRouteParams = IExtractRouteParamMap<
  typeof courseChapterExerciseRoutesObj
>;

// * Path functions for the course-chapter-Exercises routes.
export const courseChapterExercisePath = createPaths<
  typeof courseChapterExerciseRoutesObj,
  ICourseChapterExerciseRouteParams
>(courseChapterExerciseRoutesObj);

// * Breadcrumbs {translation and route} for the course chapter Exercises routes
const thisCourseChapterExerciseBreadcrumbs = createBreadcrumbObject<
  typeof courseChapterExerciseRoutesObj
>(courseChapterExerciseRoutesObj, courseChapterExerciseRouteTranslation);

export const courseChapterExerciseBreadcrumbs = concatBreadcrumbs<
  typeof courseChapterExerciseRoutesObj
>(courseChapterBreadcrumbs.view, thisCourseChapterExerciseBreadcrumbs);
